import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";
import {
  createAd,
  fetchAdByTenant,
  deleteAd,
  adDetails,
  updateAd,
  fetchPlacementList,
  fetchEntitiesList,
  switchBannerStatus,
} from "@/services/advertisement";

@Module({
  namespaced: true,
})
export default class Advertisement extends VuexModule {
  // state
  adList = [];
  placementList = [];
  adDetail = {};
  entitiesList = [];

  //action
  @Action
  public async fetchAdListforTenant(payload) {
    try {
      const data = await fetchAdByTenant(payload);
      this.context.commit("setAdList", data.response);
      return data.response;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async getPlacementList(payload) {
    try {
      const data = await fetchPlacementList(payload);
      this.context.commit("setPlacementList", data.response);
      return data.response;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async fetchAdDetails(payload) {
    try {
      const data = await adDetails(payload);
      this.context.commit("setAdDetails", data.response);
      return data.response;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async createAd(payload) {
    try {
      return await createAd(payload);
    } catch (error) {
      throw error;
    }
  }
  @Action
  public async toSwitchBannerStatus(payload) {
    try {
      return await switchBannerStatus(payload);
    } catch (error) {
      throw error;
    }
  }
  @Action
  public async updateAdvertisement(payload) {
    try {
      return await updateAd(payload);
    } catch (error) {
      throw error;
    }
  }
  @Action
  public async deleteAd(payload) {
    try {
      return await deleteAd(payload);
    } catch (error) {
      throw error;
    }
  }
  @Action
  public async fetchEntities(payload) {
    try {
      const data = await fetchEntitiesList(payload);
      this.context.commit("setEntities", data.data);
      return data;
    } catch (error) {
      throw error;
    }
  }

  //mutation
  @Mutation
  public setAdList(data: any) {
    this.adList = data;
  }
  @Mutation
  public setPlacementList(data: any) {
    this.placementList = data;
  }
  @Mutation
  public setEntities(data: any) {
    this.entitiesList = data;
  }
  @Mutation
  public setAdDetails(data: any) {
    this.adDetail = data;
  }

  //getters
  get GetAdList() {
    return this.adList;
  }
  get GetPlacementList() {
    return this.placementList;
  }
  get GetAdDetails() {
    return this.adDetail;
  }
  get GetEntities() {
    return this.entitiesList;
  }
}
